module.exports = __webpack_public_path__ + "static/media/priest.34033ba7.png";